var logoList = document.querySelectorAll('.logo--slider .swiper-wrapper .swiper-slide');
if (logoList.length > 0) {
  logoList.forEach((logo) => {
    ["mouseover", "mouseout"].forEach(function(type){
      if(type == 'mouseover'){
        logo.addEventListener(type, (e) => {
          e.target.closest('.logo--slider').classList.add('hover-active');
        })
      } else if(type == 'mouseout'){
        logo.addEventListener(type, (e) => {
          e.target.closest('.logo--slider').classList.remove('hover-active');
        })
      }
    })
  })
}